import { Component, Mixins, Prop, Ref } from 'vue-property-decorator'
import CropperMixin from '../../mixins/cropper.mixin'
import { RootGetters } from '@/store/types'
import { Getter } from 'vuex-class'
import uniqCid from '@/helpers/uniqCid'
import { SizeImage } from '@/types/image'

@Component
export default class ExpertWidgetCropper extends Mixins(CropperMixin) {
  @Getter private readonly getPlatform!: RootGetters['getPlatform']
  @Prop({ type: Boolean, default: false }) private readonly readOnly!: boolean
  @Prop({ type: Boolean, default: false })
  private readonly isAdvertExpert!: boolean
  @Prop({ type: Boolean, default: false })
  private readonly isValidCropper!: boolean

  @Ref('imageSource') private readonly imageSourceRef?: {
    resetForm: () => void
  }

  private get cropperBgColor() {
    return 'white'
  }

  private get isValid() {
    return this.localCropperImages.every(
      ({ transform }) =>
        !!transform.image?.id || !!transform.image?.copyrightImage?.source
    )
  }

  private onLoadImageFile(params: { file?: File; image?: SizeImage }) {
    if (params.image) {
      this.onCropperImageUploader({
        width: params.image.width,
        height: params.image.height,
        id: params.image.id,
        url: params.image.url,
        file: params.file,
        copyrightImage: params.image?.copyrightImage || {
          url: '',
          source: '',
          source_url: '',
        },
        cid: uniqCid().toString(),
      })

      return
    }

    if (!params.file) return
    const imageUrl = URL.createObjectURL(params.file)
    const image = new Image()

    image.src = imageUrl

    image.onload = () => {
      this.onCropperImageUploader({
        width: image.width,
        height: image.height,
        id: 0,
        url: imageUrl,
        file: params.file,
        copyrightImage: params.image?.copyrightImage || {
          url: '',
          source: '',
          source_url: '',
        },
        cid: uniqCid().toString(),
      })
    }
  }

  private onLoadCopyrightFile(file: File, index: number) {
    if (this.usedOneImageForAllCropperImages || index === -1) {
      this.localCropperImages.forEach((image) => {
        if (!image.transform.image?.copyrightImage) return
        image.transform.image.copyrightImage.copyright_file = file
      })
    } else {
      const cropperImage = this.localCropperImages[index]

      if (!cropperImage?.transform?.image?.copyrightImage) return

      cropperImage.transform.image.copyrightImage.copyright_file = file
    }
  }

  private onImageDelete(index: number) {
    this.onCropperReplaceImage(index)
    this.imageSourceRef?.resetForm()
  }

  private created() {
    this.$watch(
      () => {
        return this.cropperImages.reduce((acc, { transform: { id } }) => {
          acc += `-${id}`
          return acc
        }, this.$vuetify.breakpoint.name.toString())
      },
      this.initCropper,
      {
        immediate: true,
      }
    )
  }

  private mounted() {
    this.$watch(
      () => {
        return this.isAdvertExpert
      },
      () => {
        this.refreshCropper()
      }
    )

    this.$watch(
      () => {
        return this.isValid
      },
      () => {
        this.$emit('update:is-valid-cropper', this.isValid)
      },
      {
        immediate: true,
      }
    )
  }
}
